import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1173df3b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-page" }
const _hoisted_2 = { class: "app-wrapper" }
const _hoisted_3 = { class: "app-main" }

import {useRoute} from "vue-router";
import {Headerbar} from "../headerbar";
import {Footerbar} from "../footerbar";
import {ContactUs, SignNewsletter} from "@/features";
import {computed} from "vue";
import {useDataStore} from "@/shared";


export default /*#__PURE__*/_defineComponent({
  __name: 'base-layout',
  setup(__props) {

const {getShowForm} = useDataStore();

const router = useRoute();

const showContactUs = computed(() => {
  return getShowForm(router.name.toString(), true);
});

const showNewsletter = computed(() => {
  return getShowForm(router.name.toString(), false);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Headerbar)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_router_view, null, {
              default: _withCtx(({ Component, route }) => [
                _createVNode(_Transition, {
                  mode: "out-in",
                  name: "slide-x"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
                      key: route.path
                    }))
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    (showNewsletter.value)
      ? (_openBlock(), _createBlock(_unref(SignNewsletter), { key: 0 }))
      : _createCommentVNode("", true),
    (showContactUs.value)
      ? (_openBlock(), _createBlock(_unref(ContactUs), { key: 1 }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Footerbar))
  ]))
}
}

})